"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRootQuestionNode = void 0;
function createRootQuestionNode() {
    return {
        enabled: true,
        root: true,
        questionId: null,
        nodeId: 'root',
        type: null,
        title: 'root',
        parentNodeId: null,
    };
}
exports.createRootQuestionNode = createRootQuestionNode;
exports.default = createRootQuestionNode;
